import { render, staticRenderFns } from "./OTagInput.vue?vue&type=template&id=ab641cda&scoped=true&"
import script from "./OTagInput.vue?vue&type=script&lang=js&"
export * from "./OTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab641cda",
  null
  
)

export default component.exports